import { createResponseObject } from '../modalActions';
import * as Constants from '../../utilities/constants/Constants';

export class Theme {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.internalName = data.internal_name;
    this.thumbnailPath = data.thumbnail_path;
    this.thumbnailWidth = data.thumbnail_width;
    this.thumbnailHeight = data.thumbnail_height;
    this.sceneIds = data.scene_ids;
    this.elementIds = data.element_ids;
    this.photoIds = data.photo_ids;
    this.parentId = data.parent_id;
    this.needsAuthenetication = data.needs_authenetication;
    this.isLocalized = data.is_localized;
    this.locNames = data.loc_names;
    this.exclusiveProductIds = data.exclusive_product_ids;
    this.price = data.price;
    this.fonts = data.fonts;
    this.hostedContentThemeId = data.hosted_content_theme_id;
    this.themes = setThemes(data.themes);
    if (Object.prototype.hasOwnProperty.call(data, 'use_material')) {
      this.useMaterial = data.use_material;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'price')) {
      if (Object.prototype.hasOwnProperty.call(data.price, 'msrp')) {
        this.msrpPrice = new Price(data.price.msrp);
      }
      if (Object.prototype.hasOwnProperty.call(data.price, 'your_price')) {
        this.yourPrice = new Price(data.price.your_price);
      }
    }
  }
}
export class Price {
  constructor(data) {
    this.base = data.base;
    this.currencySymbol = data.currency_symbol;
    this.perSqft = data.per_sqft;
    this.vat = data.vat;
    this.perSqftCategory = data.per_sqft_category;
  }
}

const setThemes = themes => createResponseObject(themes, Constants.THEME_KEY);

export class ChildTheme {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.imageSource = data.image_source;
    this.parentId = data.parent_id;
    this.childThemes = createResponseObject(
      data.child_themes,
      Constants.CHILD_THEME_KEY
    );
    this.contents = createResponseObject(
      data.contents,
      Constants.USER_PHOTO_TYPE,
      Constants.HOSTED_CONTENT_IMAGE_SOURCE
    );
  }
}
